module.exports = __webpack_public_path__ + "img/header-of.9509b6cc.jpg";